import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import CircularProgress from '@material-ui/core/CircularProgress'
import PageHeading from '../../components/page-heading'
import CurrentUserDisplay from '../../components/current-user-display'
import CurrentUserCard from '../../components/current-user-card'
import Redirect from '../../components/redirect'
import { useReturnTo } from '../../lib/return-to'

const WelcomePage = () => {
  const returnTo = useReturnTo()
  return (
    <CurrentUserDisplay
      fallback={<Redirect to="/login" />}
    >
      {({ currentUser }) => (
        <>
          <PageHeading
            heading={`Welcome ${currentUser.firstName}!`}
          />
          <Box mt={-2} mb={2}>
            <CurrentUserCard currentUser={currentUser}/>
          </Box>
          <Box mb={3} display="flex" alignItems="center" justifyContent="center">
            <Box pr={2}>
              <Typography>Redirecting...</Typography>
            </Box>
            <CircularProgress color="primary" size={16} />
          </Box>
          <Redirect external to={returnTo || 'https://www.pga.com'} />
        </>
      )}
    </CurrentUserDisplay>
  )
}

export default WelcomePage
